import { render, staticRenderFns } from "./costShiftPage.vue?vue&type=template&id=34663ef0&scoped=true"
import script from "./costShiftPage.vue?vue&type=script&lang=js"
export * from "./costShiftPage.vue?vue&type=script&lang=js"
import style0 from "./costShiftPage.vue?vue&type=style&index=0&id=34663ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34663ef0",
  null
  
)

export default component.exports